module.exports = __webpack_public_path__ + "img/走进子拓.38fb0714.png";